import { __extends } from "tslib";
import ValidationDisplayHelper from './DisplayHelper';
export var RuleSeverity;
(function (RuleSeverity) {
    RuleSeverity[RuleSeverity["None"] = 0] = "None";
    RuleSeverity[RuleSeverity["Info"] = 10] = "Info";
    RuleSeverity[RuleSeverity["Warning"] = 20] = "Warning";
    RuleSeverity[RuleSeverity["AsyncBusy"] = 30] = "AsyncBusy";
    RuleSeverity[RuleSeverity["Error"] = 40] = "Error";
})(RuleSeverity || (RuleSeverity = {}));
var ValidationState = /** @class */ (function () {
    function ValidationState() {
        /** Normal severity */
        this.severity = RuleSeverity.None;
        /** Normally None, unless e.g. addError(..., force = true) was called. Then this rule will be shown regardless of validation display mode. */
        this.forceDisplaySeverity = RuleSeverity.None;
    }
    Object.defineProperty(ValidationState.prototype, "isValid", {
        get: function () {
            return this.severity < RuleSeverity.AsyncBusy;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Gets the error display information.
     * @param canDisplayAll True if the bound controls have de-focused, or the form attempted to submit.
     */
    ValidationState.prototype.getDisplayInfo = function (canDisplayAll) {
        return ValidationDisplayHelper.getDisplayInfo(this, canDisplayAll);
    };
    return ValidationState;
}());
export { ValidationState };
var ContainerValidationState = /** @class */ (function (_super) {
    __extends(ContainerValidationState, _super);
    function ContainerValidationState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.brokenRules = [];
        return _this;
    }
    Object.defineProperty(ContainerValidationState.prototype, "hasDetail", {
        get: function () {
            return this.brokenRules.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Gets the error display information.
     * @param canDisplayAll True if the bound controls have de-focused, or the form attempted to submit.
     */
    ContainerValidationState.prototype.getDisplayInfo = function (canDisplayAll) {
        if (canDisplayAll && !this.displayInfoAll) {
            this.displayInfoAll = ValidationDisplayHelper.getDisplayInfo(this, true);
        }
        if (!canDisplayAll && !this.displayInfoSome) {
            this.displayInfoSome = ValidationDisplayHelper.getDisplayInfo(this, false);
        }
        return canDisplayAll ? this.displayInfoAll : this.displayInfoSome;
    };
    ContainerValidationState.prototype.merge = function (ruleState) {
        if (ruleState.hasDetail) {
            this.brokenRules.push(ruleState);
        }
        this.update(ruleState);
    };
    ContainerValidationState.prototype.update = function (ruleState) {
        this.severity = Math.max(this.severity, ruleState.severity);
        this.forceDisplaySeverity = Math.max(this.forceDisplaySeverity, ruleState.forceDisplaySeverity);
    };
    return ContainerValidationState;
}(ValidationState));
export { ContainerValidationState };
